import React from 'react';
import { Button } from '@dotcom/crown-ui';
import { FooterContentProps } from '../wam-instructions-drawer-types';
import styles from '../wam-instructions-drawer.module.scss';

export const FooterContent = ({
  inputRef,
  buttonRef,
  handleImageUpload,
  footerContentText,
}: FooterContentProps): React.ReactElement => (
  <>
    <Button
      id="wam-upload-button"
      onClick={() => {
        inputRef.current?.click();
      }}
      className={styles['upload-button']}
      ref={buttonRef}
    >
      {footerContentText}
    </Button>
    <input
      type="file"
      aria-labelledby="wam-upload-button"
      data-testid="wam-upload-input"
      ref={inputRef}
      onChange={handleImageUpload}
      style={{ display: 'none' }}
      accept="image/jpeg,image/jpg,image/gif,image/png,image/heic,image/heif,image/webp "
    />
  </>
);
